import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { changeBetSetting } from 'services/changeBetSetting';
import { changeUserStatus } from 'services/changeUserStatus';
import { NotificationManager } from 'react-notifications';

export const changeBetSettingAsync = createAsyncThunk(
    'changeBetSetting',
    async (data, { rejectWithValue }) => {
        try {
            const response = await changeBetSetting(data);
            if (response?.status === 200) {
                NotificationManager.success('Bet setting changed successfully', 'Success', 3000);
            } else {
                NotificationManager.error('Failed to change bet setting', 'Error', 3000);
            }
            return response?.data;
        } catch (error) {
            return rejectWithValue(error.message);
        }
    }
);


const changeBetSettingSlice = createSlice({
    name: 'changeBetSetting',
    initialState: {
        data: [],
        loading: false,
        error: null,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(changeBetSettingAsync.pending, (state) => {
                state.loading = true;
                state.error = null;
            })
            .addCase(changeBetSettingAsync.fulfilled, (state, action) => {
                state.loading = false;
                state.data = action?.payload?.data;
            })
            .addCase(changeBetSettingAsync.rejected, (state, action) => {
                state.loading = false;
                state.error = action.payload;
            });
    },
});

export default changeBetSettingSlice.reducer;